import {CUSTOM_FIELD_RESOURCES} from '@/components/query/custom-fields';
import FILTER_TYPES from '@/components/query/filter-types';
import FILTER_SOURCE_TYPES from '@/components/query/filter-source-type';
import _ from '@/common/helpers';

export default {
    id: 'customers',
    version: 1,
    filterSpec: {
        id: {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'customers',
                labelBuilder: ({id, email}) => `${_.truncate(id, {limit: 11, dots: true})} - ${email}`,
                value: 'id',
            },
        },
        email: {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'customers',
                labelBuilder: ({email}) => email,
                value: 'email',
            },
        },
        tags: {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'tags',
                labelBuilder: ({name}) => name,
                value: 'name',
            },
        },
        last4: {
            label: 'Last 4',
            type: FILTER_TYPES.text,
        },
        bin: {
            type: FILTER_TYPES.text,
        },
        payPalUsername: {
            label: 'PayPal Username',
            type: FILTER_TYPES.text,
        },
        defaultPaymentMethodName: {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.definitions,
                path: 'Method/enum',
            },
        },
        defaultCardExternalId: {
            type: FILTER_TYPES.text,
        },
        firstName: {
            type: FILTER_TYPES.text,
        },
        lastName: {
            type: FILTER_TYPES.text,
        },
        createdTime: {
            type: FILTER_TYPES.datetime,
        },
        updatedTime: {
            type: FILTER_TYPES.datetime,
        },
        invoiceCount: {
            type: FILTER_TYPES.numeric,
        },
        'lifetimeRevenue/amount': {
            type: FILTER_TYPES.numeric,
            label: 'Lifetime Revenue',
        },
        paymentCount: {
            label: 'Payments Count',
            type: FILTER_TYPES.numeric,
        },
        lastPaymentTime: {
            label: 'Last Payment Time',
            type: FILTER_TYPES.datetime,
        },
        'averageValue/amount': {
            label: 'Average Value',
            type: FILTER_TYPES.numeric,
        },

        // billing address
        'primaryAddress/firstName': {
            type: FILTER_TYPES.text,
        },
        'primaryAddress/lastName': {
            type: FILTER_TYPES.text,
        },
        'primaryAddress/address': {
            type: FILTER_TYPES.text,
        },
        'primaryAddress/address2': {
            type: FILTER_TYPES.text,
        },
        'primaryAddress/organization': {
            type: FILTER_TYPES.text,
        },
        'primaryAddress/city': {
            type: FILTER_TYPES.text,
        },
        'primaryAddress/region': {
            type: FILTER_TYPES.text,
        },
        'primaryAddress/country': {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.countries,
            },
        },
        'primaryAddress/postalCode': {
            type: FILTER_TYPES.text,
        },
        'primaryAddress/email': {
            type: FILTER_TYPES.text,
        },
        'primaryAddress/phoneNumber': {
            type: FILTER_TYPES.text,
        },

        // lead source
        'leadSource/campaign': {
            type: FILTER_TYPES.text,
        },
        'leadSource/medium': {
            type: FILTER_TYPES.text,
        },
        'leadSource/source': {
            type: FILTER_TYPES.text,
        },
        'leadSource/term': {
            type: FILTER_TYPES.text,
        },
        'leadSource/content': {
            type: FILTER_TYPES.text,
        },
        'leadSource/affiliate': {
            type: FILTER_TYPES.text,
        },
        'leadSource/subAffiliate': {
            type: FILTER_TYPES.text,
        },
        'leadSource/salesAgent': {
            type: FILTER_TYPES.text,
        },
        'leadSource/amount': {
            type: FILTER_TYPES.numeric,
        },
        'leadSource/path': {
            type: FILTER_TYPES.text,
        },
        kycAccepted: {
            type: FILTER_TYPES.boolean,
        },
        kycRejected: {
            type: FILTER_TYPES.boolean,
        },
        customFields: {
            type: FILTER_TYPES.custom,
            options: {resourceType: CUSTOM_FIELD_RESOURCES.customers},
        },
        websiteId: {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'websites',
                labelBuilder: ({id}) => `${_.truncate(id, {limit: 17, dots: true})}`,
                value: 'id',
            },
        },
    },
};
